<div class="viewport" [class.active]="active">
  <div #strip class="strip">
    @for (i of barIndices; track i) {
      <div #bar class="bar"></div>
    }
  </div>
</div>
